<template>
  <div>
    <div v-if="loading" class="d-flex flex-column align-items-center justify-content-center pt-5">
      <div class="mb-3">{{ $t('sentence.please_wait_data_loaded') }}</div>
      <v-loader/>
    </div>
    <div
      class="card card-table mb-5 table-wrapper"
      v-else-if="data.sessions.length > 0"
    >
      <table
        class="m-0 table table-striped table-bordered"
      >
        <thead>
        <tr>
          <td class="answer-cell">
            {{ $t('word.gender') }}
          </td>
          <td class="answer-cell-date">
            {{ $t('word.birth_year') }}
          </td>
          <td class="answer-cell-date">
            {{ $t('word.province') }}
          </td>
          <td class="answer-cell">
            {{ $t('word.finished') }}
          </td>
          <td
            class="answer-cell"
            v-for="(researchItem, index) in filteredResearchItems"
            :key="researchItem.id"
          >
            <span class="badge badge-dark badge-pill mr-2">{{ index + 1 }}</span>
            <span v-html="formattedItemText(researchItem.title)"/>
          </td>
        </tr>
        </thead>
        <tbody v-if="data.sessions">
        <tr v-for="session in currentSessions" :key="session.id">
          <td>
            <span v-if="session.gender">{{ stringToPrettyGender(session.gender) }}</span>
            <span v-else>-</span>
          </td>
          <td>
            <span v-if="session.birth_year">{{ session.birth_year }}</span>
            <span v-else>-</span>
          </td>
          <td>
            <span
              v-if="session.province"
              class="province"
            >{{ session.province }}</span>
            <span v-else>-</span>
          </td>
          <td>
            {{ stringToPrettyDateTime(session.reviewed) }}
          </td>
          <v-answer-list-cell
            v-for="researchItem in filteredResearchItems"
            :key="researchItem.id"
            :answer="session.answerDict[researchItem.id] || null"
            :render-type="researchItem.item.render_type"
          />
        </tr>
        </tbody>
      </table>
      <div
        class="position-fixed table-nav d-flex justify-content-end bg-dark p-2"
      >
        <div class="table-nav-item">
          <v-button
            v-if="page > 1"
            @click="page -= 1"
            icon="chevron-left"
            style-type="secondary"
            :block="true"
            size="sm"
          />
        </div>
        <div class="table-nav-item text-center text-white">
          <span>{{ $t('word.page') }} {{ page }} / {{ maxPage }}</span>
        </div>
        <div class="table-nav-item">
          <v-button
            v-if="data.sessions.length > page * 100"
            @click="page += 1"
            icon="chevron-right"
            style-type="primary"
            :block="true"
            size="sm"
          />
        </div>
      </div>
    </div>
    <div v-else class="text-muted p-3 d-flex flex-column align-items-center">
      <i class="fa fa-folder-open text-large"></i>
      {{ $t('phrase.no_answers_found') }}
    </div>
  </div>
</template>

<script>
import AnswerListCell from '@/organisation/components/research/AnswerListCell.vue';
import Button from '@/common/components/Button.vue';
import Loader from '@/common/components/Loader.vue';
import { stringToPrettyDateTime } from '@/common/utils/formatting';
import { formattedItemText } from '@/common/services/items';
import { mapGetters } from 'vuex';

export default {
  name: 'AnswerList',
  components: {
    'v-answer-list-cell': AnswerListCell,
    'v-button': Button,
    'v-loader': Loader,
  },
  data() {
    return {
      sessionBatches: [],
      page: 1,
    };
  },
  computed: {
    ...mapGetters('researches', [
      'researchItems',
      'loadingResearchReviewSessions',
      'loadingResearchItems',
      'data',
    ]),
    loading() {
      return this.loadingResearchReviewSessions || this.loadingResearchItems;
    },
    filteredResearchItems() {
      return this.researchItems.filter((researchItem) => researchItem.item.render_type !== 'media');
    },
    currentSessions() {
      return this.data.sessions.slice((this.page - 1) * 100, this.page * 100);
    },
    maxPage() {
      return Math.ceil(this.data.sessions.length / 100);
    },
  },
  methods: {
    formattedItemText,
    stringToPrettyDateTime,
    stringToPrettyGender(gender) {
      return {
        f: this.$t('word.female'),
        m: this.$t('word.male'),
        o: this.$t('word.other'),
      }[gender];
    },
  },
};
</script>

<style scoped>
.answer-cell {
  min-width: 200px;
}

.answer-cell-date {
  min-width: 100px;
}

.table-wrapper {
  width: 100%;
  overflow-x: scroll;
}

.province {
  text-transform: uppercase;
}

.table-nav {
  bottom: 0;
  left: 0;
  right: 0;
}

.table-nav-item {
  width: 200px;
}

@media (max-width: 991px) {
  .table-nav {
    left: 0;
  }
  .table-nav-item {
    width: 100px;
  }
}
</style>
